// Midrun client - consume your API

// See documentation

import mid from './dist/index.js';

export default mid;
